import * as zod from 'zod';

export const HaasSerialTarget = zod.object({
  kind: zod.literal('HaasRS232'),
  path: zod.string(),
});

export type HaasSerialTarget = zod.infer<typeof HaasSerialTarget>;
